<p-carousel
  class="border-round-md overflow-hidden"
  #carousel
  [value]="teaserItems"
  [showNavigators]="false"
  [showIndicators]="teaserItems.length > 1"
  [numVisible]="1"
  [autoplayInterval]="autoplayIntervall"
  [numScroll]="1">
  <ng-template let-item pTemplate="item">
    <div
      class="h-full w-full p-3 pb-6 flex justify-content-center flex-column bg-cover bg-center bg-no-repeat relative"
      [style]="
        'background-color:' +
        (item.backgroundColor || 'transparent') +
        '; background-image: url(' +
        getImageSrc(item) +
        ')'
      ">
      @if (item.header || item.content || item.topmark) {
        <div
          class="p-card bg-white-alpha-80 p-3 mb-3 overflow-auto"
          style="max-height: 75%">
          <header class="mb-3">
            @if (item.topmark) {
              <span class="text-xs">{{ item.topmark }}</span>
            }
            @if (item.header) {
              <h3>
                {{ removeHtmlFromString(item.header) }}
              </h3>
            }
          </header>
          @if (item.content) {
            <div [innerHTML]="item.content"></div>
          }
        </div>
      }
      @if (item.bookmark && bookmarkStore.getById(item.bookmark); as bookmark) {
        <app-bookmark-button
          class="mb-2"
          [bookmark]="bookmark"></app-bookmark-button>
      }
      @if (item.bookmark && storyStore.getById(item.bookmark); as story) {
        <app-story-button class="mb-2" [story]="story"></app-story-button>
      }
      @if (item.bookmark && topicStore.getById(item.bookmark); as topic) {
        <app-topic-button class="mb-2" [topic]="topic"></app-topic-button>
      }
      @if (item.href) {
        <a
          target="_blank"
          icon="fas fa-external-link-square"
          class="w-auto ml-auto mr-auto no-underline"
          pButton
          [href]="item.href"
          [label]="item.linkCaption || 'weiterlesen'"
          [rounded]="true"></a>
      }
      @if (getSource(item); as source) {
        <div
          class="teaser-source text-xs absolute bottom-0 left-0 flex align-items-center gap-2 border-round-2xl p-card m-3 pr-3 pl-2 py-1">
          <i class="fas fa-camera"></i>
          <span [innerHTML]="source"></span>
        </div>
      }
    </div>
  </ng-template>
</p-carousel>
